import React, { Component } from 'react';

import { Paper } from '@material-ui/core';

export default class LeftPanelCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goToSlides: 0,
      Carousel: '',
    };
  }

  componentDidMount() {
    /* eslint-disable global-require */
    import('react-spring-3d-carousel').then(module => this.setState({ Carousel: module.default }));
    /* eslint-enable global-require */
    // console.log('hey');

    this.timer = window.setInterval(() => {
      const { goToSlides } = this.state;
      let t = goToSlides + 1;
      if (t > 5) {
        t = 0;
      }
      this.setState({
        goToSlides: t,
      });
    }, 2000);
  }

  componentWillUnmount() {
    window.clearInterval(this.timer);
  }

  getSlides() {
    return [
      {
        key: 1,
        content: (
          <div>
            <img src="images/service4.svg" alt="1" />
            <span>Procure directly from farmers</span>
          </div>
        ),
      },
      {
        key: 12,
        content: (
          <div>
            <img src="images/service3.svg" alt="1" />
            <span>Check geographic claim risk</span>
          </div>
        ),
      },
      {
        key: 13,
        content: (
          <div>
            <img src="images/service2.svg" alt="1" />
            <span>Fetch real time crop insights</span>
          </div>
        ),
      },
      {
        key: 14,
        content: (
          <div>
            <img src="images/service1.svg" alt="1" />
            <span>Connect with over 70k dealers</span>
          </div>
        ),
      },
      {
        key: 15,
        content: (
          <div>
            <img src="images/service5.svg" alt="1" />
            <span>Generate Credit Worthiness</span>
          </div>
        ),
      },
    ];
  }

  render() {
    const { Carousel, goToSlides } = this.state;
    return (
      <React.Fragment>
        <Paper
          style={{ width: '100%', height: '200px', marginLeft: '0' }}
          className="root farmBtnsHead commonPadding"
        >
          {Carousel ? (
            <Carousel
              slides={this.getSlides()}
              showNavigation={false}
              goToSlide={goToSlides}
            />
          ) : null}
        </Paper>
      </React.Fragment>
    );
  }
}
